module.exports = __webpack_public_path__ + "static/img/bcg_k_fes.83a03c46.png";